
<template>
	<div>
		<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/idp/1.jpg" style="height: 100%;"/>
		<img v-show="this.$i18n.locale == 'en'" src="../../../public/pic/idp/e1.jpg" style="height: 100%;"/>
	
			<p style="font-size: 40px;font-weight: bold;">{{ $t('lang.homedis24')}}</p>
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/idp/2.jpg" />
			<img v-show="this.$i18n.locale == 'en'" src="../../../public/pic/idp/e2.jpg" />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/idp/3.jpg" />
			<img v-show="this.$i18n.locale == 'en'" src="../../../public/pic/idp/e3.jpg" />
			<img v-show="this.$i18n.locale == 'zh'"  src="../../../public/pic/idp/4.jpg" />
			<img v-show="this.$i18n.locale == 'en'"  src="../../../public/pic/idp/e4.jpg" />
			<img v-show="this.$i18n.locale == 'zh'"  src="../../../public/pic/idp/5.jpg" />
			<img v-show="this.$i18n.locale == 'en'"  src="../../../public/pic/idp/e5.jpg" />
			<img v-show="this.$i18n.locale == 'zh'"  src="../../../public/pic/idp/6.jpg" />
			<img v-show="this.$i18n.locale == 'en'"  src="../../../public/pic/idp/e6.jpg" />
			<img v-show="this.$i18n.locale == 'zh'"  src="../../../public/pic/idp/7.jpg" />
			<img v-show="this.$i18n.locale == 'en'"  src="../../../public/pic/idp/e7.jpg" />
			<img v-show="this.$i18n.locale == 'zh'"  src="../../../public/pic/idp/8.jpg" />
			<img v-show="this.$i18n.locale == 'en'"  src="../../../public/pic/idp/e8.jpg" />
			<img v-show="this.$i18n.locale == 'zh'"  src="../../../public/pic/idp/9.jpg" />
			<img v-show="this.$i18n.locale == 'en'"  src="../../../public/pic/idp/e9.jpg" />
			<img v-show="this.$i18n.locale == 'zh'"  src="../../../public/pic/idp/10.jpg" />
			<img v-show="this.$i18n.locale == 'en'"  src="../../../public/pic/idp/e10.jpg" />
			<img v-show="this.$i18n.locale == 'zh'"  src="../../../public/pic/idp/11.jpg" />
			<img v-show="this.$i18n.locale == 'en'"  src="../../../public/pic/idp/e11.jpg" />
			<img v-show="this.$i18n.locale == 'zh'"  src="../../../public/pic/idp/12.jpg" />
			<img v-show="this.$i18n.locale == 'en'"  src="../../../public/pic/idp/e12.jpg" />
			<img v-show="this.$i18n.locale == 'zh'"  src="../../../public/pic/idp/13.jpg" />
			<img v-show="this.$i18n.locale == 'en'"  src="../../../public/pic/idp/e13.jpg" />
			<img v-show="this.$i18n.locale == 'zh'"  src="../../../public/pic/idp/14.jpg" />
			<img v-show="this.$i18n.locale == 'en'"  src="../../../public/pic/idp/e14.jpg" />
			<!-- <p style="font-size: 40px;font-weight: bold;">{{ $t('lang.homedis4')}}</p>
			<img v-show="this.$i18n.locale == 'zh'" style="width: 50%;" src="../../../public/pic/idp/6.jpg" />
			<img v-show="this.$i18n.locale == 'en'" style="width: 50%;" src="../../../public/pic/idp/6.jpg" />
			<table border="5" style="border-collapse: collapse; width:100%;">
				<tr>
					<td class="black" style="width: 200px;">{{ $t('lang.homedis5')}}</td>
					<td class="black">{{ $t('lang.homedis6')}}</td>
				</tr>
				<tr>
					<td class="black" style="width: 200px;">{{ $t('lang.homedis7')}}</td>
					<td class="black">{{ $t('lang.homedis8')}}</td>
				</tr>
				<tr>
					<td class="black" style="width: 200px;">{{ $t('lang.homedis9')}}</td>
					<td class="black">{{ $t('lang.homedis10')}}</td>
				</tr>
				<tr>
					<td class="black" style="width: 200px;">{{ $t('lang.homedis11')}}</td>
					<td class="black">{{ $t('lang.homedis12')}}</td>
				</tr>
				<tr>
					<td class="black" style="width: 200px;">{{ $t('lang.homedis13')}}</td>
					<td class="black">{{ $t('lang.homedis14')}}</td>
				</tr>
				<tr>
					<td class="black" style="width: 200px;">{{ $t('lang.homedis15')}}</td>
					<td class="black">{{ $t('lang.homedis16')}}</td>
				</tr>
				<tr>
					<td class="black" style="width: 200px;">{{ $t('lang.homedis17')}}</td>
					<td class="black">{{ $t('lang.homedis18')}}</td>
				</tr>
				<tr>
					<td class="black" style="width: 200px;">{{ $t('lang.homedis19')}}</td>
					<td class="black">{{ $t('lang.homedis20')}}</td>
				</tr>
				
			</table>
			<br /><br /> -->
			
		
	</div>
	
	
</template>

<script>
export default {
	head(){
		return {
			title : '家庭智能消毒机器人_深圳全智能机器人科技有限公司 Home intelligent disinfection robot_ Shenzhen all intelligent robot technology Co., Ltd',
			keywords : '家庭智能消毒机器人,家用消毒杀菌机器人,家居杀菌消毒设备,小型喷雾消毒机器人,消杀设备厂家，全智能消杀机器人 Home intelligent disinfection robot, home disinfection robot, home furnishing sterilization equipment, small spray disinfection robot, disinfection equipment manufacturer, all intelligent disinfection robot',
			description : '深圳全智能机器人科技有限公司研发生产的家庭智能消毒机器人有专业的智能高功率高频悬浮雾化系统----将消毒液体近乎均匀地微粒化，使其滞空时间更长；5～100μm负电荷消毒液微粒-----自动追踪，除尘、杀菌两不误。  The home intelligent disinfection robot developed and produced by Shenzhen all intelligent robot technology Co., Ltd. has a professional intelligent suspension atomization system with high-power high-frequency, which can almost uniformly granulate the disinfectant liquid, making it stay in the air longer; 5-100 μ m negative charge disinfectant particles - automatic tracking, dust removal and sterilization.',
		};
	},
}
</script>

<style scoped>
	.black{
		color: white;
		height:50px;
		font-size: 20px;
		font-weight: bold;
	}
	.black1{
		line-height: 40px;
		font-size: 18px;
	}
	img{
		width: 100%;
	}
</style>
